import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onCreateImpressionWhenView"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LinkBox } from '@hub/link';
import React, { useImperativeHandle } from 'react';
import { forwardRef } from '@hub/design-system-base';
import useAnalyticsObserver from './use-analytics-observer';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackLinkBox = forwardRef((_ref, ref) => {
  let {
    onCreateImpressionWhenView
  } = _ref,
      linkBoxProps = _objectWithoutProperties(_ref, _excluded);

  const {
    inViewRef
  } = useAnalyticsObserver({
    onCreateImpressionWhenView
  });
  useImperativeHandle(ref, () => ({
    focus: () => {
      inViewRef();
    }
  }));

  if (!onCreateImpressionWhenView) {
    return /*#__PURE__*/_jsx(LinkBox, _objectSpread(_objectSpread({}, linkBoxProps), {}, {
      "data-id": "analytics-observer_track-link-box_TrackLinkBox_LinkBox"
    }));
  }

  return /*#__PURE__*/_jsx(LinkBox, _objectSpread(_objectSpread({
    ref: inViewRef
  }, linkBoxProps), {}, {
    "data-id": "analytics-observer_track-link-box_TrackLinkBox_LinkBox_1"
  }));
});